import React from 'react'

import { useRouter } from 'next/router'
import { useDispatch } from 'react-redux'
// styles
import styles from './index.module.scss'
import ImageWithFoster from 'components/ImageWithFoster'

// resources
import MerchHubIcon from 'assets/icons/store-icon.svg?component'
import SettingIcon from 'assets/icons/setting-icon-17x17.svg?component'
import ShoppingCartIcon from 'assets/icons/shoppingcart-icon-navbar.svg?component'

const MobileMenuUser = props => {
  const { icon, username } = props
  const router = useRouter()
  const dispatch = useDispatch()

  const handleClick = type => {
    dispatch({ type: 'set', openMobileMenu: false })
    let path = '/'
    if (type === 'store') {
      path = '/' + username + '/merch'
    } else if (type === 'studio') {
      path += '/merch-logs'
    } else if (type === 'settings') {
      path += '/settings'
    }
    router.push(path)
  }

  return (
    <div className={styles.container}>
      <div className="w-full flex justify-center pt-[33px]">
        <div className={styles.avatarArea}>
          <ImageWithFoster src={icon} width={46} height={46} className="w-full rounded-full" />
        </div>
      </div>
      <div className="w-full flex justify-center mt-[15px]">
        <div
          className={styles.userName}
          onClick={() => {
            dispatch({ type: 'set', openMobileMenu: false })
            router.push(`/${username}`)
          }}
        >
          {username}
        </div>
      </div>
      <div className="w-full flex justify-between mt-[30px] px-[23px]">
        <div className="flex flex-col items-center gap-[9px]" onClick={() => handleClick('store')}>
          <MerchHubIcon />
          <div className={styles.text}>My Store</div>
        </div>
        <div className={styles.separator} />
        <div className="flex flex-col items-center gap-[9px]" onClick={() => handleClick('studio')}>
          <ShoppingCartIcon />
          <div className={styles.text}>Studio Hub</div>
        </div>
        <div className={styles.separator} />
        <div className="flex flex-col items-center gap-[9px]" onClick={() => handleClick('settings')}>
          <SettingIcon />
          <div className={styles.text}>Settings</div>
        </div>
      </div>
    </div>
  )
}

export default MobileMenuUser
